import { Component, OnInit } from '@angular/core';
import { ShopifyService } from '../../shared/services/shopify.service';
import { Data, ErrorResponse, Product, HeroContent, PageContentItem } from '../../shared/model/store.models';
import { BehaviorSubject, catchError, from, of } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.scss'],
})
export class StoreComponent implements OnInit {
  collectionData$ = new BehaviorSubject<Data | null>(null);
  products$ = new BehaviorSubject<Product[]>([]);
  heroContent$ = new BehaviorSubject<HeroContent | null>(null);
  pageContent$ = new BehaviorSubject<PageContentItem[]>([]);
  error$ = new BehaviorSubject<ErrorResponse | null>(null);

  constructor(
    private shopifyService: ShopifyService,
    private meta: Meta,
    private titleService: Title
  ) { }

  ngOnInit() {
    from(this.shopifyService.getCollectionByHandle('garmin-watches')).pipe(
      catchError((error) => {
        this.error$.next(error as ErrorResponse);
        return of(null);
      }),
    ).subscribe((response) => {
      if (response) {
        if ('errors' in response) {
          this.error$.next(response);
        } else {
          this.collectionData$.next(response);
          this.products$.next(response.collectionByHandle.products.edges.map(({ node }) => node));

          const rawHeroContent = response.collectionByHandle
            .metafields.find((metafield) => metafield.key === 'hero_content')?.value;
          if (rawHeroContent) {
            this.heroContent$.next(JSON.parse(rawHeroContent).heroContent as HeroContent);
          }

          const rawPageContent = response.collectionByHandle
            .metafields.find((metafield) => metafield.key === 'page_content')?.value;
          if (rawPageContent) {
            this.pageContent$.next(JSON.parse(rawPageContent).pageContent as PageContentItem[]);
          }

          // Update meta tags
          this.updateMetaTags(
            response.collectionByHandle.title,
            response.collectionByHandle.description,
            this.heroContent$.value?.header.style.backgroundImage.desktop,
          );
        }
      }
    });
  }

  updateMetaTags(title: string, description: string, imageUrl?: string): void {
    const head = document.getElementsByTagName('head')[0];

    this.titleService.setTitle(title);
    this.meta.updateTag({ name: 'description', content: description });

    const metaTags = [
      { name: 'og:title', content: title },
      { name: 'og:description', content: description },
    ];

    const twitterTags = [
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
    ];

    if (imageUrl) {
      metaTags.push({ name: 'og:image', content: imageUrl });
      twitterTags.push({ name: 'twitter:image', content: imageUrl });
    }

    metaTags.forEach(tag => {
      let element = document.querySelector(`meta[property='${tag.name}']`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('property', tag.name);
        head.appendChild(element);
      }
      element.setAttribute('content', tag.content);
    });

    twitterTags.forEach(tag => {
      let element = document.querySelector(`meta[name='${tag.name}']`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('name', tag.name);
        head.appendChild(element);
      }
      element.setAttribute('content', tag.content);
    });
  }
}
